import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {RecruiterProductivityActions} from 'src/action-creators/analytics/analytics-recruiter-productivity';
import type {
  RecruitmentFilters,
  SavedDashboardList,
  SelectedRecruiterFilterColumnsData,
} from 'src/types/analytics-genesis';

import {
  CLEAR_SELECTED_FILTERS,
  SET_SELECTED_DATE_RANGE,
  RECEIVE_SAVED_DASHBOARDS,
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_FILTERS,
  RECEIVE_RECRUITER_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-recruiter-productivity';


export type RecruiterProductivityState = {
  savedDashboards: SavedDashboardList;
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  selectedFilters: RecruitmentFilters;
  recruiterTableColumnFilter: SelectedRecruiterFilterColumnsData | null;
};

const initialState: RecruiterProductivityState = {
  selectedFilters: {
    job_status: [],
  },
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  recruiterTableColumnFilter: null,
  savedDashboards: [],
  currentDashboardID: null,
};

export default (
  state: RecruiterProductivityState = initialState,
  action: RecruiterProductivityActions,
): RecruiterProductivityState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }

    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }

    case SET_SELECTED_FILTERS: {
      const {selectedFilters} = state;
      return {
        ...state,
        selectedFilters: {
          ...selectedFilters,
          ...action.payload,
        },
      };
    }

    case CLEAR_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          job_status: [],
        },
      };
    }
    case RECEIVE_RECRUITER_TABLE_COLUMNS: {
      return {...state, recruiterTableColumnFilter: action.payload};
    }
  }

  return state;
};
